module.exports = __webpack_public_path__ + "b494ba75a60610337e960043d6b2c456.jpg";